/**
 * A tab open across a deploy can ask for a chunk it cannot get. The error
 * boundary's "Try again" re-renders the same code and fails the same way, so
 * this is the one error a reload fixes: once, with a guard against a loop when
 * the reload does not help (RFC deploy-safety-2026-11 §2.7).
 */
const STORAGE_KEY = 'novixone:chunk-reload-at'
/** A second failure inside this window means the reload did not help. */
const LOOP_WINDOW_MS = 60_000

export function isChunkLoadError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false
  const { name, message } = error as { name?: unknown; message?: unknown }
  if (name === 'ChunkLoadError') return true
  return typeof message === 'string'
    && /Loading (CSS )?chunk [^\s]+ failed|Failed to load chunk|Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(message)
}

/** True when a reload was started: render nothing, the page is going away. */
export function reloadOnceForChunkError(error: unknown): boolean {
  if (!isChunkLoadError(error) || typeof window === 'undefined') return false
  try {
    const last = Number(window.sessionStorage.getItem(STORAGE_KEY) ?? 0)
    if (Date.now() - last < LOOP_WINDOW_MS) return false
    window.sessionStorage.setItem(STORAGE_KEY, String(Date.now()))
  } catch {
    // Storage blocked: a loop guard cannot be kept, so the person decides.
    return false
  }
  window.location.reload()
  return true
}
